import { CompactUserResponse } from '@business/entities/account';
import { ChannelId, CompactChannelResponse, SupportChannelRuleResponse } from '@business/entities/SupportChannel';

export type ChannelAssignId = string;

export enum SupportChannelAssignType {
  user = 'user',
  channel_rule = 'channel_rule',
}

export enum ChannelAssignStatusEnum {
  verified = 'verified',
  unverified = 'unverified',
}

export enum ChannelAssignDnsValid {
  unknown = 'unknown',
  valid = 'valid',
}

export interface ChannelAssignDns {
  priority?: string;
  name: string;
  record_type: string;
  valid: ChannelAssignDnsValid;
  value: string;
}

export interface SupportChannelAssginResponse {
  id: ChannelAssignId;
  type: SupportChannelAssignType;
  email: string;
  name: string;
  assignTo: string;
  user?: CompactUserResponse;
  rule?: SupportChannelRuleResponse;
  status: ChannelAssignStatusEnum;
  sendingDns: ChannelAssignDns[];
  receivingDns: ChannelAssignDns[];
  domain: string;
  channelId: ChannelId;
  isDefault: boolean;
  secret: string;
  channel?: CompactChannelResponse;
  mailgunDomain: 'yes' | 'no' | 'unknown';
}

export type SupportChannelAssginRequest = Pick<SupportChannelAssginResponse, 'type' | 'email' | 'name'> & {
  userId: string;
};

export interface ChannelEmailSender {
  id: ChannelAssignId;
  email: string;
}

export interface ChannelEmailVerifyRequest {
  secret: string;
}
